import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../App';
import './AppLayout.css';

const NAV_ITEMS = [
  { path: '/dashboard', icon: 'fa-house', label: 'Tableau de bord' },
  { path: '/transfers', icon: 'fa-right-left', label: 'Virements' },
  { path: '/history', icon: 'fa-clock-rotate-left', label: 'Historique' },
  { path: '/company', icon: 'fa-briefcase', label: 'Entreprise' },
];

export default function AppLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="app-layout">
      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <img src="/logo.png" alt="Fleeca" className="sidebar-logo-img"
              onError={e => { e.target.style.display = 'none'; }} />
            <span className="sidebar-logo-text">Fleeca Bank</span>
          </div>
          <button className="sidebar-close" onClick={() => setSidebarOpen(false)}>
            <i className="fa-solid fa-xmark" />
          </button>
        </div>

        {/* User info */}
        {user && (
          <div className="sidebar-user">
            <img
              src={user.avatar
                ? `https://cdn.discordapp.com/avatars/${user.discordId}/${user.avatar}.png?size=64`
                : '/logo.png'}
              alt="Avatar"
              className="sidebar-avatar"
              onError={e => { e.target.src = '/logo.png'; }}
            />
            <div className="sidebar-user-info">
              <span className="sidebar-char-name">{user.characterName}</span>
              <span className="sidebar-discord-name">{user.username}</span>
            </div>
          </div>
        )}

        <div className="divider" style={{ margin: '0 16px' }} />

        {/* Navigation */}
        <nav className="sidebar-nav">
          {NAV_ITEMS.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <i className={`fa-solid ${item.icon}`} />
              <span>{item.label}</span>
            </NavLink>
          ))}
          {user?.isAdmin && (
            <NavLink
              to="/admin"
              className={({ isActive }) => `sidebar-link sidebar-link-admin ${isActive ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <i className="fa-solid fa-shield-halved" />
              <span>Panel Admin</span>
            </NavLink>
          )}
        </nav>

        <div className="sidebar-footer">
          <button className="sidebar-logout" onClick={handleLogout}>
            <i className="fa-solid fa-right-from-bracket" />
            <span>Deconnexion</span>
          </button>
        </div>
      </aside>

      {/* Overlay mobile */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Main content */}
      <div className="app-main">
        {/* Top bar mobile */}
        <header className="app-topbar">
          <button className="topbar-burger" onClick={() => setSidebarOpen(true)}>
            <i className="fa-solid fa-bars" />
          </button>
          <div className="topbar-logo">
            <img src="/logo.png" alt="Fleeca" style={{ height: 24 }}
              onError={e => { e.target.style.display = 'none'; }} />
            <span>Fleeca Bank</span>
          </div>
          {user && (
            <img
              src={user.avatar
                ? `https://cdn.discordapp.com/avatars/${user.discordId}/${user.avatar}.png?size=64`
                : '/logo.png'}
              alt="Avatar"
              className="topbar-avatar"
              onError={e => { e.target.src = '/logo.png'; }}
            />
          )}
        </header>

        <main className="app-content">
          {children}
        </main>
      </div>
    </div>
  );
}
